import React, { FC, forwardRef } from 'react';

import { Typography, useDesktop } from 'Modules/ui3';
import { useTranslation } from 'Modules/core/i18n';

import { statusColor } from './utils';
import { EmissionStatus } from '../../api';
import { DfaStatusProps } from './types';


export const DfaStatus: FC<DfaStatusProps> = forwardRef(({ status, customText, variant = 'active', ...props }, ref) => {
    const { t } = useTranslation('dfaStatus');
    const isDesktop = useDesktop();

    const text = status === EmissionStatus.other
        ? customText
        : t(status) as string;
    const isActive = variant === 'active';
    const color = statusColor[status];
    return (
        <Typography
            ref={ref}
            component='div'
            color={isActive ? color.text : 'grayscale.shade90'}
            variant={isDesktop ? 'regularCaption3' : 'mediumMicro1'}
            py={isActive ? 0.75 : 1}
            px={isActive ? 2.75 : 3}
            borderRadius={10}
            textAlign='center'
            {...!isDesktop && {
                fontWeight: 400,
            }}
            {...isActive ? {
                border: '1px solid',
                borderColor: color.border,
            } : {
                bgcolor: 'grayscale.shade10',
            }}
            {...variant === 'disabled' && {
                sx: {
                    opacity: '0.5',
                },
            }}
            title={text}
            {...props}
        >
            {text}
        </Typography>
    );
});
